import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const run = async () => {
            const hash = location.hash || "";
            const match = hash.match(/session_id=([^&]+)/);
            if (!match) { navigate("/login", { replace: true }); return; }
            const sessionId = decodeURIComponent(match[1]);
            try {
                await api.post("/auth/session", { session_id: sessionId });
                window.history.replaceState(null, "", window.location.pathname);
                const u = await refresh();
                if (u && !u.onboarded) navigate("/onboarding", { replace: true });
                else navigate("/dashboard", { replace: true });
            } catch (e) {
                navigate("/login", { replace: true });
            }
        };
        run();
    }, [location, navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-darkblue" data-testid="auth-callback">
            <div className="text-center">
                <div className="w-12 h-12 border-4 border-white/20 border-t-mineral rounded-full animate-spin mx-auto mb-4" />
                <p className="text-white/80 font-heading">Autenticando com segurança...</p>
            </div>
        </div>
    );
}
